import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-bg text-dark-text p-8 md:p-16">
      <div className="max-w-3xl mx-auto space-y-8">
        <header className="border-b border-dark-border pb-6">
          <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
          <p className="text-dark-text-secondary mt-2">Last updated: May 18, 2026</p>
        </header>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">1. Introduction</h2>
          <p>
            TalentFirst ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">2. Information We Collect</h2>
          <p>
            We collect information that you provide directly to us, such as when you create or update your profile, upload a CV, or communicate with us. This may include:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Name and contact information (email, phone number)</li>
            <li>Professional experience and education history</li>
            <li>Skills, certifications, and languages</li>
            <li>Profile picture and other information you choose to provide</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">3. How We Use Your Information</h2>
          <p>
            We use the information we collect to:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Provide, maintain, and improve our services</li>
            <li>Process and manage your profile and applications</li>
            <li>Communicate with you about our services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect the security of your personal information. However, please note that no method of transmission over the Internet or method of electronic storage is 100% secure.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">5. Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, or delete your data.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-blue-300">6. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at privacy@talentfirst.com.
          </p>
        </section>

        <footer className="pt-8 border-t border-dark-border text-center">
          <a href="/" className="text-blue-400 hover:text-blue-300 font-medium">
            ← Back to TalentFirst
          </a>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
